<template>
    <form @submit.prevent="submit" class="fuid-border-bottom">

        <b-row>

            <b-col cols="12">

                <errorFromServer :id="componentId" />

            </b-col>

        </b-row>

        <b-row>

            <b-col cols="12">

                <b-row>

                    <b-col cols="12">

                        <label class="fuid-form__label">{{ $t('forms.applicant.dni') }}<span
                                class="fuid-required_ask">*</span></label>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.dni.$error }">


                        <input class="fuid-form__input" v-model.trim="fields.dni" />

                        <div class="error-c">

                            <!-- <div v-if="personaValidated" class>{{$t('forms.applicant.validated')}}</div> -->
                            <!-- <div class="error error--visible" v-if="personaCheckError" >{{$t('forms.applicant.checkError')}}</div> -->
                            <!-- <div class="error" v-if="!$v.fields.dni.dni">{{$t('forms.dni')}}</div> -->
                            <div class="error" v-if="!$v.fields.dni.required">{{ $t('forms.required') }}</div>

                        </div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group d-flex">

                        <button @click.prevent="applicantPersonCheck" class="fuid-button-check">

                            <b-spinner v-if="personaChecking" label="Loading..."></b-spinner>

                            <span v-else>{{ $t('forms.applicant.check') }}</span>

                        </button>

                    </b-col>

                </b-row>

            </b-col>

        </b-row>

        <b-row v-if="formToRender == 1">

            <b-col cols="12">

                <b-row>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.email.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.email') }}<span
                                class="fuid-required_ask">*</span></label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.email.$model" />
                        <div class="error" v-if="!$v.fields.email.required">{{ $t('forms.required') }}</div>
                        <div class="error" v-if="!$v.fields.email.email">{{ $t('forms.email') }}</div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.emailRepeat.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.emailRepeat') }}<span
                                class="fuid-required_ask">*</span></label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.emailRepeat.$model" />
                        <div class="error" v-if="!$v.fields.emailRepeat.required">{{ $t('forms.required') }}</div>
                        <div class="error" v-if="!$v.fields.emailRepeat.email">{{ $t('forms.email') }}</div>
                        <div class="error" v-if="!$v.fields.emailRepeat.sameAs">{{ $t('forms.sameAs') }}</div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.applicant.cp') }}</label>
                        <input class="fuid-form__input" v-model="fields.codigoPostal" />

                    </b-col>

                </b-row>

            </b-col>

            <b-col cols="12">

                <b-row>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.applicant.colegio') }}</label>
                        <input class="fuid-form__input" v-model="fields.colegio" />

                    </b-col>


                    <b-col cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.applicant.empresa') }}</label>
                        <input class="fuid-form__input" v-model="fields.empresa" />

                    </b-col>

                    <b-col v-if="getLocalizacion[0].numAbonado" cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.applicant.estadio') }}</label>
                        <input class="fuid-form__input" v-model="fields.estadio" />

                    </b-col>

                </b-row>

            </b-col>

        </b-row>

        <b-row v-if="formToRender == 2">

            <b-col cols="12">

                <b-row>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.nombre.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.nombre') }}<span
                                class="fuid-required_ask">*</span></label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.nombre.$model" />
                        <div class="error" v-if="!$v.fields.nombre.required">{{ $t('forms.required') }}</div>
                        <div class="error" v-if="!$v.fields.nombre.minLength">{{ $t('forms.min', {
                            length:
                                $v.fields.nombre.$params.minLength.min
                        }) }}</div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.apellidos.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.apellidos') }}<span
                                class="fuid-required_ask">*</span></label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.apellidos.$model" />
                        <div class="error" v-if="!$v.fields.apellidos.required">{{ $t('forms.required') }}</div>
                        <div class="error" v-if="!$v.fields.apellidos.minLength">{{ $t('forms.min', {
                            length:
                                $v.fields.apellidos.$params.minLength.min
                        }) }}</div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.telefono.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.telefono') }}<span
                                class="fuid-required_ask">*</span></label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.telefono.$model" />
                        <div class="error" v-if="!$v.fields.telefono.required">{{ $t('forms.required') }}</div>
                        <div class="error" v-if="!$v.fields.telefono.minLength">{{ $t('forms.min', {
                            length:
                                $v.fields.telefono.$params.minLength.min
                        }) }}</div>

                    </b-col>

                </b-row>

                <b-row>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.email.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.email') }}<span
                                class="fuid-required_ask">*</span></label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.email.$model" />
                        <div class="error" v-if="!$v.fields.email.required">{{ $t('forms.required') }}</div>
                        <div class="error" v-if="!$v.fields.email.email">{{ $t('forms.email') }}</div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group"
                        :class="{ 'form-group--error': $v.fields.emailRepeat.$error }">

                        <label class="fuid-form__label">{{ $t('forms.student.emailRepeat') }}<span
                                class="fuid-required_ask">*</span></label>
                        <input class="fuid-form__input" v-model.trim="$v.fields.emailRepeat.$model" />
                        <div class="error" v-if="!$v.fields.emailRepeat.required">{{ $t('forms.required') }}</div>
                        <div class="error" v-if="!$v.fields.emailRepeat.email">{{ $t('forms.email') }}</div>
                        <div class="error" v-if="!$v.fields.emailRepeat.sameAs">{{ $t('forms.sameAs') }}</div>

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.applicant.cp') }}</label>
                        <input class="fuid-form__input" v-model="fields.codigoPostal" />

                    </b-col>

                </b-row>

                <b-row>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.applicant.colegio') }}</label>
                        <input class="fuid-form__input" v-model="fields.colegio" />

                    </b-col>

                    <b-col cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.applicant.empresa') }}</label>
                        <input class="fuid-form__input" v-model="fields.empresa" />

                    </b-col>

                </b-row>

                <b-row>

                    <b-col v-if="getLocalizacion[0].numAbonado" cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.applicant.estadio') }}</label>
                        <input class="fuid-form__input" v-model="fields.estadio" />

                    </b-col>

                    <b-col v-if="formas.length" cols="12" md="6" lg="4" class="fuid-form-group">

                        <label class="fuid-form__label">{{ $t('forms.applicant.como') }}</label>

                        <select class="fuid-form__input" name id v-model="fields.forma">

                            <option v-for="(fo, index) in formas" :key="index" :value="fo.id">
                                {{ $t(`formas.${fo.codigoTraduccion}`) }}</option>

                        </select>

                    </b-col>

                    <b-col :class="{ 'form-group--error': $v.fields.amigo.$error }" cols="12" md="6" lg="4"
                        class="fuid-form-group">

                        <div class="d-none">

                            <label class="fuid-form__label">{{ $t('forms.applicant.amigo') }}</label>
                            <input class="fuid-form__input" v-model="fields.amigo" />
                            <div class="error" v-if="!$v.fields.amigo.numeric">{{ $t('forms.student.checkError') }}</div>

                        </div>

                    </b-col>

                </b-row>

            </b-col>

        </b-row>

    </form>
</template>

<script>
// ----------------------------------------------------------
// To map shit from Vuex
// ----------------------------------------------------------
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
// ----------------------------------------------------------
// Validator for vuelidate
// ----------------------------------------------------------
import { required, minLength, between, email, numeric, sameAs } from "vuelidate/lib/validators"
import dni from "@/mixins/validatorDni";
// ----------------------------------------------------------
// Components
// ----------------------------------------------------------
import errorFromServer from '@/components/errorFromServer'
// ----------------------------------------------------------
// Mixins
// ----------------------------------------------------------
import scrollTo from '@/mixins/scrollTo'
// ----------------------------------------------------------
// API
// ----------------------------------------------------------
import { getAllFormas } from "@/api/formaconocer.api";

export default {

    data() {

        return {

            componentId: 1678,
            personaChecking: false,
            personaCheckError: false,
            personaValidated: false,
            formToRender: 0,
            formas: [],
            applicantId: null,
            f: null,
            s_data: {},
            dataUptoDate: false,
            personaUpdate: false,
            fields: {
                dni: '',
                email: '',
                emailRepeat: '',
                codigoPostal: '',
                colegio: '',
                empresa: '',
                estadio: '',
                nombre: '',
                apellidos: '',
                telefono: '',
                forma: '',
                amigo: '',
                amigook: null,
                amigos: []
            }

        }

    },

    components: {

        errorFromServer

    },

    mixins: [scrollTo],

    validations() {

        /**
         * Conditional validations
         *
         */

        if (this.formToRender == 2) {

            this.f = {

                fields: {

                    dni: {
                        required,
                        // dni
                    },
                    email: {
                        required,
                        email
                    },
                    emailRepeat: {
                        required,
                        email,
                        sameAs: sameAs(function () { return this.fields.email })
                    },
                    nombre: {
                        required,
                        minLength: minLength(3)
                    },
                    apellidos: {
                        required,
                        minLength: minLength(3)
                    },
                    telefono: {
                        required,
                        minLength: minLength(9)
                    },
                    amigo: {}

                }

            }

        }

        if (this.formToRender == 1) {

            this.f = {

                fields: {

                    email: {
                        required,
                        email
                    },
                    emailRepeat: {
                        required,
                        email,
                        sameAs: sameAs(function () { return this.fields.email })
                    },
                    dni: {
                        required,
                        // dni
                    },

                }

            }


        }

        if (this.formToRender == 0) {

            this.f = {

                fields: {

                    dni: {
                        required,
                        // dni
                    },

                    dniRepeat: {
                        required,
                        sameAs: sameAs(function () { return this.fields.dniRepeat })
                    }

                }

            }

        }

        if (this.fields.amigo !== '') {

            this.f.fields.amigo = {

                numeric

            }

        }

        return this.f

    },

    async created() {

        try {

            const response = await getAllFormas()

            if (response.statusText == "OK") {

                this.formas = response.data
                this.setFormas(response.data)

            }

        } catch (error) {

            this.$store.dispatch('Errors/setError', { error: 'CODE20', componentId: this.componentId }, { root: true })

        }

    },

    computed: {

        ...mapGetters('Localizaciones', ['getLocalizacion']),
        ...mapGetters('Prematricula', ['getCurso']),
        ...mapGetters('Personas', ['getNuevosByDni']),

        solicitanteEsAlumno() {

            let isAlumno = this.getNuevosByDni(this.fields.dni)

            if (isAlumno.length > 0) {

                return isAlumno

            } else {

                return false

            }

        }

    },

    methods: {

        /**
         * Map actions from Vuex
         *
         */

        ...mapActions("Personas", ["checkPersonaReferencia"]),
        ...mapActions("Personas", ["checkPersona"]),
        ...mapActions("Personas", ["createPersona"]),
        ...mapActions("Personas", ["putPersona"]),
        ...mapActions('Personas', ["setPersona"]),
        ...mapActions('Personas', ["setFormas"]),
        ...mapActions("Prematricula", ["setPersonaPrematricula"]),
        ...mapActions("Prematricula", ["setField"]),
        ...mapActions("Prematricula", ["postPrematricula"]),
        ...mapActions("Prematricula", ["setPersonaPrematricula"]),
        ...mapActions("Prematricula", ["checkSolicitantePrematricula"]),

        /**
         * Send the form
         *
         */

        async submit() {

            /**
             * First check the validation of the fields
             *
             */

            this.personaCheckError = false

            this.$v.$touch()

            let valid;

            if (this.$v.$invalid) {

                valid = false

            } else {

                valid = true

            }

            /**
             * If theres NOT a solicitant persona in the system lets create a new persona for the solicitant
             *
             */

            if (this.formToRender == 2 && valid) {

                this.s_data = {
                    dni: this.fields.dni === '' ? null : this.fields.dni,
                    nombre: this.fields.apellidos + ', ' + this.fields.nombre,
                    telefono: this.fields.telefono,
                    email: this.fields.email,
                    codigoPostal: this.fields.codigoPostal,
                }

                // If the solicitante is the same person of a new alumno
                if (this.solicitanteEsAlumno || this.personaValidated) {

                    let id

                    if (this.solicitanteEsAlumno) {

                        id = this.solicitanteEsAlumno[0].id

                    } else {

                        id = this.applicantId

                    }

                    this.personaValidated = await this.putPersona({ id: id, componentId: this.componentId, data: this.s_data })

                    this.applicantId = this.personaValidated.data.id
                    this.s_data.id = this.personaValidated.data.id

                } else {

                    this.personaValidated = await this.createPersona({ data: this.s_data, componentId: this.componentId })

                    this.applicantId = this.personaValidated.id
                    this.s_data.id = this.personaValidated.id

                }

                this.s_data.antiguo = 0

                this.dataUptoDate = true

            }

            /**
             * If there IS a persona in the system update email & codigoPostal in persona solicitante
             *
             */

            if (this.formToRender == 1 && valid) {

                this.s_data = {
                    email: this.fields.email,
                    codigoPostal: this.fields.codigoPostal,
                }

                try {

                    let updatePersona = await this.putPersona({ id: this.applicantId, componentId: this.componentId, data: this.s_data })

                    if (updatePersona.statusText == 'OK' && updatePersona.data.id != '') {

                        this.s_data.dni = this.fields.dni
                        this.dataUptoDate = true

                    }


                } catch (error) {

                    this.$store.dispatch('Errors/setError', { error: 'CODE19', componentId: this.componentId }, { root: true })

                }

            }

            // If we have the solicitant ID set to Prematricula store
            this.setPersonaPrematricula({ persona: this.applicantId })

            // Populate extra fields to Prematricula store
            this.populateNonPersonaFields()

            // Set solicitante to personas Store
            this.setPersona(this.s_data)

            let amigo_data = await this.checkAmigo()

            // If everything is OK to the resume Step
            if (valid && amigo_data && this.dataUptoDate) {

                // Emit this is valid to the home component
                this.$emit('toFinalStep', {

                    id: this.componentId,
                    valid: true

                })

            } else {

                this.$emit('toFinalStep', {

                    id: this.componentId,
                    valid: false

                })

                this.scrollToError()
                this.$store.dispatch('Errors/setError', { error: 'CODE21', componentId: this.componentId }, { root: true })

            }

        },

        /**
         * Populate fields in prematricula outside of persona & alumnos
         *
         */

        async populateNonPersonaFields() {

            this.setField({ colegio: this.fields.colegio })
            this.setField({ empresa: this.fields.empresa })
            this.setField({ estadio: this.fields.estadio })

            this.s_data.colegio = this.fields.colegio
            this.s_data.empresa = this.fields.empresa
            this.s_data.estadio = this.fields.estadio
            this.s_data.forma = this.fields.forma

            if (this.fields.forma != '') {

                this.setField({ formaConocer: this.fields.forma })

                // If is not amigo clear the value
                if (this.fields.forma != 1) {

                    this.fields.amigo = ''
                    this.fields.amigos = []

                }

            }

        },

        /**
         * Check the code of the amigo
         *
         */

        async checkAmigo() {

            try {

                if (this.fields.amigo === '') return true

                let referencia_check = this.fields.amigo === '' ? 'undefined' : this.fields.amigo

                const amigoResponse = await this.checkPersonaReferencia({ codigo: referencia_check, componentId: this.componentId })

                if (amigoResponse !== false) {

                    this.fields.amigook = amigoResponse.id
                    this.s_data.amigo = amigoResponse.id
                    this.s_data.amigoAlt = null
                    this.setField({ amigo: amigoResponse.id })
                    this.setField({ amigoAlt: null })

                    return true

                } else {

                    let amigoAlt = this.fields.amigo

                    this.fields.amigook = null
                    this.s_data.amigoAlt = this.fields.amigo
                    this.s_data.amigo = null
                    this.setField({ amigoAlt: amigoAlt })
                    this.setField({ amigo: null })

                    return true

                }

            } catch (error) {

                this.$store.dispatch('Errors/setError', { error: 'CODE19', componentId: this.componentId }, { root: true })

            }

        },

        /**
         * Validate person by DNI and person has no prematriculas in the current curso
         *
         */

        async applicantPersonCheck() {

            if (this.solicitanteEsAlumno) {

                this.personaCheckError = false
                this.formToRender = 2

                return

            }

            this.personaChecking = true
            this.personaValidated = false

            let dni_check = this.fields.dni === '' ? 'undefined' : this.fields.dni

            this.personaValidated = await this.checkPersona({ dni: dni_check, componentId: this.componentId })

            this.applicantId = this.personaValidated.id

            //console.log(this.applicantId)

            if (this.personaValidated !== false) {

                let prematricula_check = await this.checkSolicitantePrematricula({ idpersona: this.applicantId, idcurso: this.getCurso, componentId: this.componentId })

                //console.log(prematricula_check)

                if (prematricula_check) {

                    this.personaValidated = false
                    this.personaCheckError = false
                    this.$store.dispatch('Errors/setError', { error: 'CODE26', componentId: this.componentId }, { root: true })


                } else {

                    this.personaCheckError = false
                    this.formToRender = 1

                }

            } else {

                this.personaCheckError = true
                this.formToRender = 2

            }

            this.personaChecking = false

        }

    },

}
</script>